const UrlFriendly = (str?: string) => {
  if (!str) {
    return '';
  }

  return str
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
};

const UpdateHashAndOpenLink = (
  e: React.MouseEvent<HTMLAnchorElement>,
  hash: string,
  url: string
) => {
  e.preventDefault();

  if (history.pushState) {
    history.pushState(null, '', `#${hash}`);
  } else {
    window.location.hash = hash;
  }

  window.open(url, '_self');
};

const Debounce = (func: () => void, delay: number) => {
  let timeout: NodeJS.Timeout;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };
};

export { UrlFriendly, UpdateHashAndOpenLink, Debounce };
